import React from 'react'
import PropTypes from 'prop-types'
import { NavLink } from 'react-router-dom'

import './NavigationMenuDesktop.sass'


const NavigationMenuDesktop = () => {
  return (
    <nav className="navigation-menu navigation-menu-desktop" role="navigation">
      <NavLink to="/about" activeClassName="is-active-link">About the Project</NavLink>
      <NavLink to="/resources" activeClassName="is-active-resource-parent-link">Resources</NavLink>
      <div className="resource-links">
        <NavLink
          to="/resources/glossary"
          className="resource-link"
          activeClassName="is-active-resource-link"
        >
          Glossary
        </NavLink>
        <NavLink
          to="/resources/case-studies"
          className="resource-link"
          activeClassName="is-active-resource-link"
        >
          Case Study Libraries
        </NavLink>
        <NavLink
          to="/resources/resource-libraries"
          className="resource-link"
          activeClassName="is-active-resource-link"
        >
          Resource Libraries
        </NavLink>
        <NavLink
          to="/resources/data-sources"
          className="resource-link"
          activeClassName="is-active-resource-link"
        >
          Data Sources
        </NavLink>
        <NavLink
          to="/resources/faqs"
          className="resource-link"
          activeClassName="is-active-resource-link"
        >
          FAQs
        </NavLink>
        <NavLink
          to="/resources/retired-tools"
          className="resource-link"
          activeClassName="is-active-resource-link"
        >
          Retired Tools
        </NavLink>
      </div>
      <NavLink to="/partners" activeClassName="is-active-link">Partners</NavLink>
      <NavLink to="/funding" activeClassName="is-active-link">Funding</NavLink>
      <NavLink to="/contact" activeClassName="is-active-link">Contact</NavLink>
    </nav>
  )
}

export default NavigationMenuDesktop
